// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import { Sentry } from '../utils/sentry';

import authReducer from './authSlice';
import userReducer from './userSlice';
import preferencesReducer from "./preferencesSlice";
import marketReducer from './marketSlice';
import dataReducer from './dataSlice';
import reportsReducer from './reportsSlice';
import performancePaneReducer from './performancePaneSlice';
import paymentGroupsReducer from './paymentGroupsSlice';
import insightsReducer from './insightsSlice';

// Sentry enhancer: captures dispatched actions as breadcrumbs (and an action
// type tag on subsequent events). State is *not* attached on each event —
// the entire Redux state per error is too much payload and may leak PII.
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  stateTransformer: () => null,
  actionTransformer: (action) => {
    // Action payloads can carry PII (emails, names, payment data) or
    // credentials (auth tokens). The action *type* alone is enough to
    // reconstruct the dispatch sequence on an error, so drop every payload.
    // See audit A260520-FE-L1.
    return action?.type ? { type: action.type } : action;
  },
});

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    preferences: preferencesReducer,
    market: marketReducer,
    data: dataReducer,
    reports: reportsReducer,
    performancePane: performancePaneReducer,
    paymentGroups: paymentGroupsReducer,
    insights: insightsReducer,
  },
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export default store;